import _ from "lodash";

export const unwrap = (val, ...args) => _.isFunction(val) ? val(...args) : val;
